/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Ccc_VersionInputs */



/**
* | output |
* | --- |
* | "Closed Caption Creator v{version}" |
*
* @param {Ccc_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccc_version = /** @type {((inputs: Ccc_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccc_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Closed Caption Creator v${i?.version}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Untertitel-Ersteller v${i?.version}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Creatore di sottotitoli v${i?.version}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создатель субтитров v${i?.version}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Creador de subtítulos cerrados v${i?.version}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`隐藏式字幕创建器 v${i?.version}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`クローズドキャプションクリエイター v${i?.version}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर v${i?.version}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Criador de legendas ocultas v${i?.version}`)
	return /** @type {LocalizedString} */ (`Closed Caption Creator v${i?.version}`)
});